module.exports = __webpack_public_path__ + "static/media/frmlogonewsml.4f16cce1.png";